module.exports = __webpack_public_path__ + "media/images/sns/tiktok_icon-944a7ac4355bace37902ef820352d7d2.png";